// Shared helpers for Settings entity pages. Promoted from screen/PhysicianManagement/shared/utils.js (MVP-31132).
/**
 * Format an entity's (physician / facility) address for display
 * @param {Object} entity - object with address, suiteNumber, city, state, zipCode
 * @returns {string} - Formatted address ("" if nothing available)
 */
export const formatAddress = (entity) => {
  const parts = [];
  if (entity.address) parts.push(`${entity.address}${entity.suiteNumber ? `, ${entity.suiteNumber}` : ""}`);
  if (entity.city || entity.state || entity.zipCode) {
    const cityState = [entity.city, entity.state].filter(Boolean).join(", ");
    const zipCode = entity.zipCode || "";
    parts.push(`${cityState} ${zipCode}`.trim());
  }
  return parts.join(", ");
};

export const getUserName = (users, userId, defaultUser) => {
  if (!userId) return defaultUser;
  const user = users[userId];
  if (user && user.firstName && user.lastName) {
    return `${user.lastName}, ${user.firstName}`;
  } else if (user && user.name && (!user.firstName || !user.lastName)) {
    return user.name;
  }
  return defaultUser;
};

// "-" placeholder for empty display values (Settings entity tables/detail pages).
export const dash = (value) => (value === null || value === undefined || value === "" ? "-" : value);

// "" and undefined both mean "no value" for dirty-tracking purposes; collapse them (and null) to a
// single sentinel so form values can be compared against loaded entity values without false positives.
export const normalizeFormValue = (value) => (value === "" || value === undefined ? null : value);

export const hasFieldChanged = (formValue, initialValue) =>
  normalizeFormValue(formValue) !== normalizeFormValue(initialValue);

// Which of `keys` differ between formValues and initialValues (dirty tracking / analytics).
export const getChangedFields = (keys, formValues, initialValues) =>
  keys.filter((key) => hasFieldChanged(formValues?.[key], initialValues?.[key]));

// Column-header sort tooltip: cycles ascend → descend → (cancel) → ascend, per entity list's i18n
// namespace (tPrefix, e.g. "facility_management.list").
export const createSortTooltipGetter = (t, tPrefix, sortColumn, sortOrder) => {
  const sortTooltipMap = {
    ascend: t(`${tPrefix}.sort_descend_tooltip`),
    descend: t(`${tPrefix}.sort_cancel_tooltip`),
    null: t(`${tPrefix}.sort_ascend_tooltip`)
  };
  return (columnKey) =>
    sortTooltipMap[sortColumn === columnKey ? sortOrder : null] ?? t(`${tPrefix}.sort_ascend_tooltip`);
};
